import $ from 'jquery';

class StatusBoxes {
  constructor() {
    this.boxes = $('.js-status-boxes-block');
    this.aspectRatio = 360 / 500;

    if (!this.boxes.length) {
      return;
    }

    this.boxesHeight();
  }

  boxesHeight() {
    this.boxes.each((index, element) => {
      const boxes = $(element);
      this.box = boxes.find('.js-status-box');

      if (this.box.length) {
        this.firstBox = boxes.find('.js-status-box').first();
        // this.boxWidth = firstBox.width();
        // this.boxMinHeight = this.boxWidth / aspectRation;
        this.setHeight();
        // box.css({ 'min-height': this.boxMinHeight });

        let debouce;
        $(window).on('resize', () => {
          clearTimeout(debouce);

          debouce = setTimeout(() => {
            this.setHeight();
            // this.boxWidth = firstBox.width();
            // this.boxMinHeight = this.boxWidth / aspectRation;
            // box.css({ 'min-height': this.boxMinHeight });
          }, 400);
        });
      }
    });
  }

  setHeight() {
    this.boxWidth = this.firstBox.width();
    this.boxMinHeight = this.boxWidth / this.aspectRatio;

    this.box.css({ 'min-height': this.boxMinHeight });
  }
}

export default new StatusBoxes();



// WEBPACK FOOTER //
// ./src/scripts/modules/status-boxes.js